import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO51 = () => {

  return (
    <StaticImage
      src="../../images/JPG-FEMALE-LOOK005-1.jpg"
      title="Reserved avatar"
      alt="Reserved avatar"
    />
  )
}

export default ImageMO51
